import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import * as $ from "jquery";

import { Global } from '../../../../global';
import { Location } from '@angular/common';

import { catchError } from 'rxjs/operators';

import { AuthService } from '../../../../service/auth/auth.service'

import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-suplier',
  templateUrl: './add-suplier.component.html',
  styleUrls: ['./add-suplier.component.css']
})
export class AddSuplierComponent implements OnInit {

  fornecedor: any = {};
  presencaUser: any = {};
  uid: string = '';

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    private global: Global,
    private location: Location,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.fornecedor.internacional = false;
    this.fornecedor.ativo = true;
    this.presencaUser = JSON.parse(localStorage.getItem('@DigtVentry:presencaUser'));

    this.uid = this.route.snapshot.paramMap.get('uuid');
    if (this.uid) {
      Swal.fire('Favor aguarde')
      Swal.showLoading()
      this.obterDadoFornecedor()
    }
  }

  obterDadoFornecedor = () => {
    this.service.Get(`Fornecedor/${this.uid}`).then(
      result => {
        this.fornecedor = result;
        if (this.fornecedor.telefone) {
          this.fornecedor.telefone = this.global.telMask(this.fornecedor.telefone)
        }
        Swal.close()
      },
      error => {
        if (error.status == 401 || error.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.fire('Erro', error.error.messagem, 'error');
      }
    )
  }

  goBack() {
    this.location.back();
  }

  mudarNacionalidade = () => {
    this.fornecedor.internacional = !this.fornecedor.internacional
    if (this.fornecedor.internacional) {
      this.fornecedor.pais = "Brasil";
    }
  }

  mudarStatus = () => {
    this.fornecedor.ativo = !this.fornecedor.ativo
  }

  salvarFornecedor = () => {
    Swal.fire('Favor aguarde')
    Swal.showLoading()

    if (!this.fornecedor.nome || this.fornecedor.nome == undefined) {
      Swal.fire('Erro', 'O nome do fornecedor deve ser informado', 'error')
      return
    }

    if (!this.fornecedor.cnpj || this.fornecedor.cnpj == undefined) {
      Swal.fire('Erro', 'O CNPJ do fornecedor deve ser informado', 'error')
      return
    }

    if (this.fornecedor.cnpj) {
      this.fornecedor.cnpj_unmask = this.fornecedor.cnpj.replace(/\D/g, "")
    }

    if (!this.fornecedor.nome_fantasia || this.fornecedor.nome_fantasia == undefined) {
      this.fornecedor.nome_fantasia = ''
    }

    if (!this.fornecedor.telefone || this.fornecedor.telefone == undefined) {
      this.fornecedor.telefone = ''
      this.fornecedor.telefone_unmask = ''
    }

    if (this.fornecedor.telefone) {
      this.fornecedor.telefone_unmask = this.fornecedor.telefone.replace(/\D/g, "")
    }

    var Obj = {
      nome: this.fornecedor.nome,
      cnpj: this.fornecedor.cnpj_unmask,
      nome_fantasia: this.fornecedor.nome_fantasia,
      internacional: this.fornecedor.internacional,
      telefone: this.fornecedor.telefone_unmask,
      ativo: this.fornecedor.ativo,
      endereco: this.fornecedor.endereco,
      pais: this.fornecedor.pais,
      numero_registro: this.fornecedor.numero_registro,
    }

    this.service.Post(`Fornecedor`, Obj).then(
      result => {
        Swal.fire('Sucesso', 'Fornecedor cadastrado com sucesso', 'success').then(
          result => {
            this.location.back()
            // this.fornecedor = {}
            // this.ngOnInit()
          }
        )
      },
      error => {
        if (error.status == 401 || error.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.fire('Erro', error.error.messagem, 'error');
      }
    )
  }

  atualizarFornecedor = () => {
    Swal.fire('Favor aguarde')
    Swal.showLoading()

    if (!this.fornecedor.nome || this.fornecedor.nome == undefined) {
      Swal.fire('Erro', 'O nome do fornecedor deve ser informado', 'error')
      return
    }

    if (!this.fornecedor.cnpj || this.fornecedor.cnpj == undefined) {
      Swal.fire('Erro', 'O CNPJ do fornecedor deve ser informado', 'error')
      return
    }

    if (this.fornecedor.cnpj) {
      this.fornecedor.cnpj_unmask = this.fornecedor.cnpj.replace(/\D/g, "")
    }

    if (!this.fornecedor.nome_fantasia || this.fornecedor.nome_fantasia == undefined) {
      this.fornecedor.nome_fantasia = ''
    }

    if (!this.fornecedor.telefone || this.fornecedor.telefone == undefined) {
      this.fornecedor.telefone = ''
      this.fornecedor.telefone_unmask = ''
    }

    if (this.fornecedor.telefone) {
      this.fornecedor.telefone_unmask = this.fornecedor.telefone.replace(/\D/g, "")
    }

    var Obj = {
      nome: this.fornecedor.nome,
      cnpj: this.fornecedor.cnpj_unmask,
      nome_fantasia: this.fornecedor.nome_fantasia,
      internacional: this.fornecedor.internacional,
      telefone: this.fornecedor.telefone_unmask,
      ativo: this.fornecedor.ativo,
      endereco: this.fornecedor.endereco,
      pais: this.fornecedor.pais,
      numero_registro: this.fornecedor.numero_registro,
    }

    this.service.Put(`Fornecedor?Id=${this.uid}`, Obj).then(
      result => {
        Swal.fire('Sucesso', 'Fornecedor atualizado com sucesso', 'success').then(
          result => {
             this.location.back()
            // Swal.fire('Favor aguarde')
            // Swal.showLoading()
            // this.obterDadoFornecedor()
          }
        )
      },
      error => {
        if (error.status == 401 || error.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.fire('Erro', error.error.messagem, 'error');
      }
    )


  }

}
